import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'bajo',
      label: i18n.t('production.low_weight'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'normal',
      label: i18n.t('common_words.normal'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'sobre',
      label: i18n.t('production.over_weight'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'total',
      label: i18n.t('common_words.total'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'peso_caja',
      label: i18n.t('production.average_net_weight'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    }
  ];

  return { Table };
};

export default configTable;
